// extracted by mini-css-extract-plugin
export default {"tab":"styles_tab__NJQUj","horizontal":"styles_horizontal__pf-qf","active":"styles_active__UUs8X","vertical":"styles_vertical__RPlnb"};